export const FlyoutOverflowHandling = {
  none: 'none',
  inversePosition: 'inversePosition',
  clockwise: 'clockwise',
  minimalOverflow: 'minimal',
  all: 'all',
}
